import React, { Component } from "react";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, formatMoney } from "../../App";
import { initEncryptionSession } from "../../encryptionSession";
import { encryptData, decryptData } from "../Crypto_Helpers/cryptoHelper";
import Cookies from "js-cookie";
import dateFormat from "dateformat";
import {
  HiOutlineArrowLeft,
  HiOutlinePlus,
  HiOutlineTrash,
  HiOutlineCash,
  HiOutlineCollection,
  HiOutlineCheckCircle,
  HiOutlinePaperAirplane,
  HiOutlineSearch,
} from "react-icons/hi";

class PharmacyEntryMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props_loading: false,
      submitting: false,
      medicineList: [],
      prescribedMedicines: [],
      patientInfo: {},
      prescription_id: 0,
      patient_id: 0,
      totalAmount: 0,
      phoneSearchQuery: "",
      searchResults: [],
      searchingPhone: false,
      showSearchDropdown: false,
    };
  }

  handlePhoneSearchChange = async (query) => {
    this.setState({ phoneSearchQuery: query });

    if (!query || query.trim().length < 3) {
      this.setState({ searchResults: [], showSearchDropdown: false });
      return;
    }

    this.setState({ searchingPhone: true, showSearchDropdown: true });
    try {
      const pharmId =
        localStorage.getItem("pharmacy_id") ||
        Cookies.get("pharmacy_id") ||
        0;
      const aesKey = await initEncryptionSession();
      const payload = {
        pharmacy_id: pharmId,
        phone: query.trim(),
      };

      let requestData = payload;
      if (aesKey) {
        try {
          const encrypted = await encryptData(payload, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = payload;
        }
      }

      const response = await axiosInstance.post(
        "pharmacy/searchPatientByPhone",
        requestData
      );

      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.rawList)) {
          list = response.data.rawList;
        } else if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      this.setState({
        searchResults: Array.isArray(list) ? list : [],
        searchingPhone: false,
      });
    } catch (err) {
      console.error("handlePhoneSearchChange error:", err);
      this.setState({ searchingPhone: false });
    }
  };

  selectPatientFromSearch = (patient) => {
    let normalizedGender = patient.gender || "";
    if (normalizedGender) {
      const g = normalizedGender.toString().trim().toLowerCase();
      if (g === "m" || g === "male") normalizedGender = "Male";
      else if (g === "f" || g === "female") normalizedGender = "Female";
      else if (g === "other") normalizedGender = "Other";
    }

    let normalizedAge = patient.age || patient.customer_dob || patient.customer_age || "";

    const updatedInfo = {
      ...this.state.patientInfo,
      customer: patient.name || "",
      phone_no: patient.phonenumber || "",
      customer_phno: patient.phonenumber || "",
      age: normalizedAge ? String(normalizedAge) : "",
      gender: normalizedGender,
      patient_id: patient.patient_id || 0,
      Name: patient.name || "",
      phonenumber: patient.phonenumber || "",
    };

    this.setState({
      patientInfo: updatedInfo,
      patient_id: patient.patient_id || 0,
      phoneSearchQuery: patient.phonenumber || "",
      showSearchDropdown: false,
      searchResults: [],
    });
  };

  handlePatientInfoChange = (field, value) => {
    const updatedInfo = {
      ...this.state.patientInfo,
      [field]: value,
    };
    if (field === "customer") updatedInfo.Name = value;
    if (field === "phone_no") {
      updatedInfo.customer_phno = value;
      updatedInfo.phonenumber = value;
    }
    this.setState({ patientInfo: updatedInfo });
  };

  componentDidMount() {
    this.initPrescriptionData();
    this.getMedicineList();
  }

  initPrescriptionData = () => {
    try {
      const data = this.props.prescriptionEntryData?.[0] || {};
      const prescriptionId = data.prescription_id || data.id || 0;
      const patientId = data.patient_id || 0;

      let normalizedGender = data.gender || data.customer_gender || "";
      if (normalizedGender) {
        const g = normalizedGender.toString().trim().toLowerCase();
        if (g === "m" || g === "male") normalizedGender = "Male";
        else if (g === "f" || g === "female") normalizedGender = "Female";
        else if (g === "other") normalizedGender = "Other";
      }

      let normalizedAge = data.age || data.customer_dob || data.customer_age || "";
      if (normalizedAge) {
        normalizedAge = normalizedAge.toString().trim();
      }

      const formattedPatientInfo = {
        ...data,
        customer: data.customer || data.name || data.Name || "",
        phone_no: data.phone_no || data.customer_phno || data.phonenumber || "",
        gender: normalizedGender,
        age: normalizedAge,
      };

      let parsedMedicines = [];
      if (data.p_medicinedetails) {
        try {
          const raw = typeof data.p_medicinedetails === "string"
            ? JSON.parse(data.p_medicinedetails)
            : data.p_medicinedetails;
          if (Array.isArray(raw)) {
            parsedMedicines = raw.map((item, idx) => {
              const days = Number(item.days) || 1;
              const counts = Array.isArray(item.counts) && item.counts.length >= 4
                ? item.counts
                : [
                    Number(item.morning) || 0,
                    Number(item.afternoon) || 0,
                    Number(item.evening) || 0,
                    Number(item.night) || 0,
                  ];
              const dailyCount = counts.reduce((a, b) => a + (Number(b) || 0), 0) || 1;
              const totalQuantity = Number(item.totalmedicine) || Number(item.quantity) || (days * dailyCount);
              const unitRate = parseFloat(item.per_tablet_price) || parseFloat(item.unit_rate) || parseFloat(item.unitRate) || parseFloat(item.originalPrice) || 0;
              const linePrice = parseFloat(item.price) || parseFloat(item.amount) || (unitRate * totalQuantity);

              return {
                id: item.id || item.medicine_id || item.value || (idx + 1),
                name: item.name || item.medicine_name || item.label || "",
                dosage: item.dosage || "",
                counts: counts,
                days: days,
                foodtype: item.foodtype !== undefined ? item.foodtype : 0,
                unitRate: unitRate,
                quantity: totalQuantity,
                amount: linePrice,
                instruction: item.instruction || "",
              };
            });
          }
        } catch (e) {
          console.error("Error parsing p_medicinedetails:", e);
        }
      }

      if (parsedMedicines.length === 0) {
        parsedMedicines = [
          {
            id: "",
            name: "",
            dosage: "",
            counts: [1, 0, 0, 1],
            days: 3,
            foodtype: 1,
            unitRate: 0,
            quantity: 6,
            amount: 0,
            instruction: "",
          },
        ];
      }

      const totalAmount = this.calculateTotalAmount(parsedMedicines);

      this.setState({
        patientInfo: formattedPatientInfo,
        prescription_id: prescriptionId,
        patient_id: patientId,
        prescribedMedicines: parsedMedicines,
        totalAmount: totalAmount,
        props_loading: false,
      });
    } catch (err) {
      console.error("initPrescriptionData error:", err);
      this.setState({ props_loading: false });
    }
  };

  getMedicineList = async () => {
    try {
      const pharmId =
        localStorage.getItem("pharmacy_id") ||
        Cookies.get("pharmacy_id") ||
        0;
      const aesKey = await initEncryptionSession();
      const payload = {
        pharmacy_id: pharmId,
        adminSts: "A",
        pageNumber: 0,
        pageSize: 0,
      };

      let requestData = payload;
      if (aesKey) {
        try {
          const encrypted = await encryptData(payload, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = payload;
        }
      }

      const response = await axiosInstance.post(
        "pharmacy/get_mas_pharm_medicine_rate",
        requestData
      );

      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      const medicineList = [];
      if (Array.isArray(list)) {
        list.forEach((val) => {
          const rate = parseFloat(val.per_tablet_price) || parseFloat(val.per_stock_price) || 0;
          medicineList.push({
            id: val.id,
            medicine_name: val.medicine_name,
            dosage: val.dosage,
            label: `${val.medicine_name}${val.dosage ? ` (${val.dosage})` : ""}`,
            unitRate: rate,
          });
        });
      }

      this.setState({ medicineList }, () => {
        // Cross-match prescribed medicines by name to get correct inventory id
        const updated = this.state.prescribedMedicines.map(med => {
          if (!med.name) return med;
          const match = medicineList.find(m => m.medicine_name === med.name || m.label === med.name);
          if (match && String(med.id) !== String(match.id)) {
            return { ...med, id: match.id, unitRate: match.unitRate || med.unitRate };
          }
          return med;
        });
        const totalAmount = this.calculateTotalAmount(updated);
        this.setState({ prescribedMedicines: updated, totalAmount });
      });
    } catch (err) {
      console.error("getMedicineList error in PharmacyEntryMaster:", err);
    }
  };

  calculateTotalAmount = (medicines) => {
    return medicines.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
  };

  handleMedicineSelect = (index, selectedId) => {
    const medicines = [...this.state.prescribedMedicines];
    const found = this.state.medicineList.find((m) => String(m.id) === String(selectedId));

    if (found) {
      const days = Number(medicines[index].days) || 1;
      const dailyCount = (medicines[index].counts || [1, 0, 0, 0]).reduce((a, b) => a + (Number(b) || 0), 0) || 1;
      const quantity = days * dailyCount;
      const amount = (found.unitRate || 0) * quantity;

      medicines[index] = {
        ...medicines[index],
        id: found.id,
        name: found.label || found.medicine_name,
        dosage: found.dosage || "",
        unitRate: found.unitRate || 0,
        quantity: quantity,
        amount: amount,
      };
    } else {
      medicines[index].id = selectedId;
    }

    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleCustomNameChange = (index, value) => {
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].name = value;
    this.setState({ prescribedMedicines: medicines });
  };

  handleTimingToggle = (medIndex, timingIndex) => {
    const medicines = [...this.state.prescribedMedicines];
    const counts = [...(medicines[medIndex].counts || [0, 0, 0, 0])];
    counts[timingIndex] = counts[timingIndex] ? 0 : 1;
    medicines[medIndex].counts = counts;

    const days = Number(medicines[medIndex].days) || 1;
    const dailyCount = counts.reduce((a, b) => a + (Number(b) || 0), 0) || 1;
    const quantity = days * dailyCount;
    const unitRate = parseFloat(medicines[medIndex].unitRate) || 0;
    medicines[medIndex].quantity = quantity;
    medicines[medIndex].amount = unitRate * quantity;

    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleDaysChange = (index, value) => {
    const days = Math.max(1, Number(value) || 1);
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].days = days;

    const dailyCount = (medicines[index].counts || [1, 0, 0, 0]).reduce((a, b) => a + (Number(b) || 0), 0) || 1;
    const quantity = days * dailyCount;
    const unitRate = parseFloat(medicines[index].unitRate) || 0;
    medicines[index].quantity = quantity;
    medicines[index].amount = unitRate * quantity;

    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleQuantityChange = (index, value) => {
    const qty = Math.max(0, Number(value) || 0);
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].quantity = qty;
    const unitRate = parseFloat(medicines[index].unitRate) || 0;
    medicines[index].amount = unitRate * qty;

    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleUnitRateChange = (index, value) => {
    const rate = Math.max(0, parseFloat(value) || 0);
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].unitRate = rate;
    const qty = Number(medicines[index].quantity) || 0;
    medicines[index].amount = rate * qty;

    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleFoodTypeChange = (index, foodtype) => {
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].foodtype = foodtype;
    this.setState({ prescribedMedicines: medicines });
  };

  handleInstructionChange = (index, instruction) => {
    const medicines = [...this.state.prescribedMedicines];
    medicines[index].instruction = instruction;
    this.setState({ prescribedMedicines: medicines });
  };

  addMedicineRow = () => {
    const medicines = [
      ...this.state.prescribedMedicines,
      {
        id: "",
        name: "",
        dosage: "",
        counts: [1, 0, 0, 1],
        days: 3,
        foodtype: 1,
        unitRate: 0,
        quantity: 6,
        amount: 0,
        instruction: "",
      },
    ];
    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  removeMedicineRow = (index) => {
    const medicines = [...this.state.prescribedMedicines];
    medicines.splice(index, 1);
    if (medicines.length === 0) {
      medicines.push({
        id: "",
        name: "",
        dosage: "",
        counts: [1, 0, 0, 0],
        days: 1,
        foodtype: 1,
        unitRate: 0,
        quantity: 1,
        amount: 0,
        instruction: "",
      });
    }
    const totalAmount = this.calculateTotalAmount(medicines);
    this.setState({ prescribedMedicines: medicines, totalAmount });
  };

  handleSubmit = async (isDirectDispense = false) => {
    const { prescribedMedicines, prescription_id, patient_id, totalAmount, patientInfo } = this.state;
    const pharmId =
      localStorage.getItem("pharmacy_id") ||
      Cookies.get("pharmacy_id") ||
      0;

    if (!prescription_id) {
      alert("Prescription ID is missing");
      return;
    }

    const formattedMedicines = prescribedMedicines.map((m, idx) => ({
      id: m.id || idx + 1,
      medicine_id: m.id,
      name: m.name || `Medicine ${idx + 1}`,
      medicine_name: m.name,
      dosage: m.dosage,
      counts: m.counts || [0, 0, 0, 0],
      morning: m.counts?.[0] || 0,
      afternoon: m.counts?.[1] || 0,
      evening: m.counts?.[2] || 0,
      night: m.counts?.[3] || 0,
      days: Number(m.days) || 1,
      foodtype: m.foodtype,
      unit_rate: parseFloat(m.unitRate) || 0,
      per_tablet_price: parseFloat(m.unitRate) || 0,
      quantity: Number(m.quantity) || 1,
      totalmedicine: Number(m.quantity) || 1,
      price: parseFloat(m.amount) || 0,
      amount: parseFloat(m.amount) || 0,
      instruction: m.instruction || "",
    }));

    this.setState({ submitting: true, submittingType: isDirectDispense ? "direct" : "quote" });

    try {
      const aesKey = await initEncryptionSession();
      const payload = {
        prescript_id: prescription_id,
        patient_id: patient_id,
        pharmacy_id: pharmId,
        total_amount: totalAmount,
        created_on: dateFormat(new Date(), "yyyy-mm-dd"),
        is_send_insurance: 0,
        is_send_patient: 1,
        prescript_medicines: formattedMedicines,
        is_direct_dispense: isDirectDispense,
      };

      let requestData = payload;
      if (aesKey) {
        try {
          const encrypted = await encryptData(payload, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = payload;
        }
      }

      await axiosInstance.post(
        "pharmacy/insertPrescriptionWithAmount",
        requestData
      );

      this.setState({ submitting: false });

      if (this.props.handleopenSuccess) {
        this.props.handleopenSuccess(
          isDirectDispense
            ? "Prescription dispensed & completed for walk-in patient!"
            : "Quote sent successfully to patient app!",
          true
        );
      }

      if (isDirectDispense && this.props.downloadInvoice) {
        const rawItem = {
          ...patientInfo,
          p_medicinedetails: formattedMedicines,
          total_amount: totalAmount,
          custom_order_id: patientInfo.custom_order_id || `PHAR${prescription_id}`,
          payment_status: 1,
        };
        this.props.downloadInvoice(rawItem);
      }

      if (this.props.getTableData) {
        this.props.getTableData();
      }
      if (this.props.getBack) {
        this.props.getBack();
      }
    } catch (err) {
      console.error("handleSubmit error:", err);
      this.setState({ submitting: false });
      if (this.props.handleopenSuccess) {
        this.props.handleopenSuccess("Failed to process prescription. Please try again.", false);
      }
    }
  };

  render() {
    const { patientInfo, prescribedMedicines, medicineList, totalAmount, submitting, submittingType } = this.state;

    return (
      <div className="space-y-6 max-w-[1600px] mx-auto animate-fadeIn">
        {/* Header Bar */}
        <div className="bg-white p-7 rounded-3xl border border-gray-100 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={this.props.getBack}
              className="w-12 h-12 rounded-2xl bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all duration-300 shadow-xs active:scale-95 group cursor-pointer"
              title="Back to Prescriptions List"
            >
              <HiOutlineArrowLeft size={22} className="group-hover:-translate-x-0.5 transition-transform" />
            </button>
            <div>
              <div className="flex items-center gap-3">
                <h1 className="text-2xl sm:text-3xl font-black text-gray-900 tracking-tight">
                  Prescription <span className="text-teal-600">Quotation & Dispense</span>
                </h1>
                <span className="px-3.5 py-1 rounded-full bg-teal-50 text-teal-700 text-xs sm:text-sm font-bold border border-teal-100 font-mono">
                  #{patientInfo.custom_order_id || patientInfo.orderId || patientInfo.prescription_id}
                </span>
              </div>
              <p className="text-sm text-gray-500 font-medium mt-0.5">
                Verify medicines, calculate totals, and choose between sending a quote to the app or direct walk-in dispensing
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={this.props.getBack}
              className="px-5 py-2.5 rounded-2xl bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-bold transition-all cursor-pointer"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={submitting}
              onClick={() => this.handleSubmit(false)}
              className="flex items-center gap-2 px-5 py-2.5 bg-blue-50 hover:bg-blue-600 text-blue-700 hover:text-white border border-blue-200 text-sm font-bold rounded-2xl transition-all shadow-xs active:scale-95 cursor-pointer disabled:opacity-50"
              title="Send price quote to patient mobile app for online approval"
            >
              <HiOutlinePaperAirplane size={18} />
              <span>{submitting && submittingType === "quote" ? "Sending..." : "Send Quote to App"}</span>
            </button>
            <button
              type="button"
              disabled={submitting}
              onClick={() => this.handleSubmit(true)}
              className="flex items-center gap-2 px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold rounded-2xl transition-all shadow-md shadow-emerald-600/20 active:scale-95 cursor-pointer disabled:opacity-50"
              title="Dispense immediately at counter for walk-in patient & print invoice"
            >
              <HiOutlineCheckCircle size={18} />
              <span>{submitting && submittingType === "direct" ? "Dispensing..." : "Direct Dispense (Walk-in)"}</span>
            </button>
          </div>
        </div>

        {/* Patient Details & Auto-Fill Mobile Search Card */}
        <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm space-y-5">
          {/* Mobile Search & Auto-Fill Toolbar */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 rounded-2xl bg-teal-50/50 border border-teal-100/80">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-teal-600 text-white flex items-center justify-center shadow-xs">
                <HiOutlineSearch size={20} />
              </div>
              <div>
                <h3 className="text-sm font-black text-gray-900 uppercase tracking-wider">Auto-Fill Patient Details</h3>
                <p className="text-xs text-gray-500 font-medium">Search by mobile number to quickly auto-populate existing patient details</p>
              </div>
            </div>

            {/* Phone Search Field with Auto-complete Dropdown */}
            <div className="relative w-full sm:w-80">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Enter mobile number (e.g. 987654...)"
                  value={this.state.phoneSearchQuery}
                  onChange={(e) => this.handlePhoneSearchChange(e.target.value)}
                  onFocus={() => {
                    if (this.state.searchResults.length > 0) this.setState({ showSearchDropdown: true });
                  }}
                  className="w-full pl-10 pr-4 py-2.5 bg-white border border-teal-200 rounded-xl text-sm font-bold text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500 shadow-xs"
                />
                <HiOutlineSearch className="absolute left-3 top-3 text-teal-600" size={18} />
                {this.state.searchingPhone && (
                  <div className="absolute right-3 top-3 text-xs font-bold text-teal-600 animate-pulse">Searching...</div>
                )}
              </div>

              {/* Auto-complete Dropdown List */}
              {this.state.showSearchDropdown && this.state.searchResults.length > 0 && (
                <div className="absolute z-50 left-0 right-0 mt-1 bg-white rounded-2xl border border-gray-200 shadow-xl max-h-60 overflow-y-auto divide-y divide-gray-100">
                  {this.state.searchResults.map((patient, idx) => (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => this.selectPatientFromSearch(patient)}
                      className="w-full text-left px-4 py-3 hover:bg-teal-50 transition-colors flex items-center justify-between cursor-pointer"
                    >
                      <div>
                        <p className="text-sm font-black text-gray-900 flex items-center gap-1.5">
                          <span>{patient.name}</span>
                          {patient.patient_id ? (
                            <span className="text-[10px] px-2 py-0.5 rounded-full bg-teal-100 text-teal-800 font-bold">Registered</span>
                          ) : (
                            <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-bold">Walk-in</span>
                          )}
                        </p>
                        <p className="text-xs text-gray-500 mt-0.5 font-mono">
                          {patient.phonenumber} {patient.gender ? `• ${patient.gender}` : ""} {patient.age ? `• ${patient.age} yrs` : ""}
                        </p>
                      </div>
                      <HiOutlineCheckCircle className="text-teal-600" size={20} />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Form Fields: Patient Name, Gender, Age, Phone */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Patient Name</label>
              <input
                type="text"
                placeholder="Enter Patient Name"
                value={patientInfo.customer || patientInfo.Name || ""}
                onChange={(e) => this.handlePatientInfoChange("customer", e.target.value)}
                className="w-full px-3.5 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-900 focus:bg-white focus:border-teal-600 outline-none"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Mobile Number</label>
              <input
                type="text"
                placeholder="Mobile Number"
                value={patientInfo.phone_no || patientInfo.customer_phno || patientInfo.phonenumber || ""}
                onChange={(e) => this.handlePatientInfoChange("phone_no", e.target.value)}
                className="w-full px-3.5 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-900 font-mono focus:bg-white focus:border-teal-600 outline-none"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Gender</label>
              <select
                value={
                  patientInfo.gender === "M" || patientInfo.gender === "male"
                    ? "Male"
                    : patientInfo.gender === "F" || patientInfo.gender === "female"
                    ? "Female"
                    : patientInfo.gender || ""
                }
                onChange={(e) => this.handlePatientInfoChange("gender", e.target.value)}
                className="w-full px-3.5 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-900 focus:bg-white focus:border-teal-600 outline-none cursor-pointer"
              >
                <option value="">-- Gender --</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Age</label>
              <input
                type="number"
                placeholder="Age in yrs"
                value={patientInfo.age || patientInfo.customer_dob || patientInfo.customer_age || ""}
                onChange={(e) => this.handlePatientInfoChange("age", e.target.value)}
                className="w-full px-3.5 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-900 focus:bg-white focus:border-teal-600 outline-none"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">Prescribed By / Date</label>
              <p className="text-sm font-bold text-teal-700 mt-1.5">
                {patientInfo.doctor_name ? `Dr. ${patientInfo.doctor_name}` : "Direct Entry"} • {dateFormat(patientInfo.prescript_date || new Date(), "dd-mmm-yyyy")}
              </p>
            </div>
          </div>
        </div>

        {/* Medicines Quotation List Card */}
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden flex flex-col">
          <div className="p-6 border-b border-gray-100 flex items-center justify-between gap-4 bg-slate-50/50">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-teal-100/70 text-teal-700 flex items-center justify-center">
                <HiOutlineCollection size={22} />
              </div>
              <h2 className="text-xl font-black text-gray-900">
                Prescribed <span className="text-teal-600">Medicines</span>
              </h2>
            </div>

            <button
              type="button"
              onClick={this.addMedicineRow}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white text-xs sm:text-sm font-bold transition-all cursor-pointer active:scale-95 shadow-2xs"
            >
              <HiOutlinePlus size={18} />
              <span>Add Medicine</span>
            </button>
          </div>

          <div className="p-6 space-y-4">
            {prescribedMedicines.map((med, index) => {
              const timingLabels = ["Morn", "Noon", "Eve", "Night"];
              return (
                <div
                  key={index}
                  className="p-5 rounded-2xl border border-gray-200/90 hover:border-teal-300 bg-white hover:bg-teal-50/10 transition-all shadow-2xs space-y-4"
                >
                  <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                    {/* Medicine Name Select / Input */}
                    <div className="flex-1 w-full">
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-500 mb-1.5">
                        Medicine #{index + 1}
                      </label>
                      <div className="flex flex-col sm:flex-row gap-2">
                        {medicineList && medicineList.length > 0 ? (
                          <select
                            value={med.id || ""}
                            onChange={(e) => this.handleMedicineSelect(index, e.target.value)}
                            className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-800 focus:bg-white focus:border-teal-600 outline-none cursor-pointer"
                          >
                            <option value="">-- Select from Pharmacy Inventory --</option>
                            {medicineList.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.label} ({m.unitRate} ₹)
                              </option>
                            ))}
                          </select>
                        ) : null}
                        <input
                          type="text"
                          placeholder="Medicine name & dosage"
                          value={med.name || ""}
                          onChange={(e) => this.handleCustomNameChange(index, e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-800 focus:bg-white focus:border-teal-600 outline-none"
                        />
                      </div>
                    </div>

                    {/* Delete button */}
                    <button
                      type="button"
                      onClick={() => this.removeMedicineRow(index)}
                      className="p-2.5 rounded-xl text-red-500 hover:bg-red-50 transition-colors cursor-pointer self-end lg:self-center"
                      title="Remove medicine"
                    >
                      <HiOutlineTrash size={20} />
                    </button>
                  </div>

                  {/* Timing pills & Duration */}
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 pt-2 border-t border-gray-100">
                    {/* Dosage Timings */}
                    <div className="col-span-2">
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-400 mb-1">
                        Daily Schedule (Times)
                      </label>
                      <div className="flex items-center gap-1.5">
                        {timingLabels.map((time, tIdx) => {
                          const active = Boolean(med.counts?.[tIdx]);
                          return (
                            <button
                              key={tIdx}
                              type="button"
                              onClick={() => this.handleTimingToggle(index, tIdx)}
                              className={`flex-1 py-1.5 px-2 rounded-xl text-xs font-bold transition-all cursor-pointer text-center border ${
                                active
                                  ? "bg-teal-600 text-white border-teal-600 shadow-xs"
                                  : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                              }`}
                            >
                              {time}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    {/* Days */}
                    <div>
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-400 mb-1">
                        Days
                      </label>
                      <input
                        type="number"
                        min="1"
                        value={med.days || 1}
                        onChange={(e) => this.handleDaysChange(index, e.target.value)}
                        className="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-800 text-center outline-none focus:border-teal-600 focus:bg-white"
                      />
                    </div>

                    {/* Food Type */}
                    <div>
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-400 mb-1">
                        Intake
                      </label>
                      <div className="flex gap-1">
                        <button
                          type="button"
                          onClick={() => this.handleFoodTypeChange(index, 0)}
                          className={`flex-1 py-1.5 px-1.5 rounded-xl text-xs font-bold border transition-all cursor-pointer ${
                            med.foodtype === 0
                              ? "bg-teal-600 text-white border-teal-600"
                              : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                          }`}
                        >
                          Before
                        </button>
                        <button
                          type="button"
                          onClick={() => this.handleFoodTypeChange(index, 1)}
                          className={`flex-1 py-1.5 px-1.5 rounded-xl text-xs font-bold border transition-all cursor-pointer ${
                            med.foodtype === 1
                              ? "bg-teal-600 text-white border-teal-600"
                              : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                          }`}
                        >
                          After
                        </button>
                      </div>
                    </div>

                    {/* Total Quantity */}
                    <div>
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-400 mb-1">
                        Total Quantity
                      </label>
                      <input
                        type="number"
                        min="1"
                        value={med.quantity || 0}
                        onChange={(e) => this.handleQuantityChange(index, e.target.value)}
                        className="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-800 text-center outline-none focus:border-teal-600 focus:bg-white"
                      />
                    </div>

                    {/* Unit Rate */}
                    <div>
                      <label className="block text-xs font-black uppercase tracking-wider text-gray-400 mb-1">
                        Rate (₹)
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={med.unitRate || 0}
                        onChange={(e) => this.handleUnitRateChange(index, e.target.value)}
                        className="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-800 text-center outline-none focus:border-teal-600 focus:bg-white"
                      />
                    </div>
                  </div>

                  {/* Instructions & Line Amount */}
                  <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2">
                    <input
                      type="text"
                      placeholder="Dosage instruction (e.g. 1 tablet after meals with warm water)"
                      value={med.instruction || ""}
                      onChange={(e) => this.handleInstructionChange(index, e.target.value)}
                      className="w-full px-3.5 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-xs font-medium text-gray-700 focus:bg-white focus:border-teal-600 outline-none"
                    />

                    <div className="shrink-0 flex items-center gap-2">
                      <span className="text-xs font-bold text-gray-400 uppercase">Amount:</span>
                      <span className="px-3.5 py-1 rounded-xl bg-teal-50 text-teal-800 font-mono text-sm font-black border border-teal-100">
                        {formatMoney(med.amount || 0)} ₹
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom Summary Bar */}
          <div className="p-7 bg-[#1e293b] text-white flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center text-teal-400 shadow-inner">
                <HiOutlineCash size={30} />
              </div>
              <div>
                <p className="text-teal-400 text-xs font-black uppercase tracking-widest opacity-80">
                  Total Quote Amount ({prescribedMedicines.length} {prescribedMedicines.length === 1 ? "medicine" : "medicines"})
                </p>
                <h3 className="text-3xl sm:text-4xl font-black text-white tracking-tight">
                  {formatMoney(totalAmount)}{" "}
                  <span className="text-lg font-bold text-teal-300/70">₹</span>
                </h3>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={this.props.getBack}
                className="px-6 py-3.5 rounded-2xl bg-white/10 hover:bg-white/20 text-white text-sm font-bold transition-all cursor-pointer"
              >
                Back to Queue
              </button>
              <button
                type="button"
                disabled={submitting}
                onClick={() => this.handleSubmit(false)}
                className="flex items-center gap-2.5 px-7 py-3.5 bg-blue-600 hover:bg-blue-500 text-white text-sm sm:text-base font-bold rounded-2xl transition-all shadow-lg shadow-blue-900/30 active:scale-95 cursor-pointer disabled:opacity-50"
                title="Send price quote to patient mobile app for online approval"
              >
                <HiOutlinePaperAirplane size={20} />
                <span>{submitting && submittingType === "quote" ? "Sending..." : "Send Quote to App"}</span>
              </button>
              <button
                type="button"
                disabled={submitting}
                onClick={() => this.handleSubmit(true)}
                className="flex items-center gap-2.5 px-8 py-3.5 bg-emerald-500 hover:bg-emerald-400 text-slate-900 text-sm sm:text-base font-black rounded-2xl transition-all shadow-lg shadow-emerald-900/40 active:scale-95 cursor-pointer disabled:opacity-50"
                title="Dispense immediately at counter for walk-in patient & print invoice"
              >
                <HiOutlineCheckCircle size={22} />
                <span>{submitting && submittingType === "direct" ? "Dispensing..." : "Direct Dispense & Bill (Walk-in)"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PharmacyEntryMaster;
